/**
 * Maps a blocked battle action to the i18n key that describes the actual cause.
 * Compound "connection lost" checks previously hid not-your-turn and auth failures.
 */

export const BATTLE_ACTION_ERROR = {
  NOT_YOUR_TURN: 'battleUI.notYourTurn',
  MISSING_GAME_ID: 'battleUI.missingGameId',
  CONNECTION_LOST: 'battleUI.connectionLost',
  SESSION_EXPIRED: 'battleUI.sessionExpired',
  ATTACKER_NOT_FOUND: 'battleUI.attackerNotFound',
  TARGET_NOT_FOUND: 'battleUI.targetNotFound',
  WEAPON_ACTION_FAILED: 'battleUI.weaponActionFailed',
};

/**
 * @param {object} options
 * @param {boolean} [options.yourTurn]
 * @param {boolean} [options.requireTurn=false]
 * @param {string|null} [options.gameId]
 * @param {boolean} [options.requireGameId=true]
 * @param {{ readyState?: number }|null} [options.socket]
 * @param {boolean} [options.requireSocket=true]
 * @returns {string|null} battleUI translation key, or null when the action may proceed
 */
export function getBattleActionBlockErrorKey(options) {
  if (!options || typeof options !== 'object') {
    throw new Error('getBattleActionBlockErrorKey: options object is required');
  }

  const {
    yourTurn,
    requireTurn = false,
    gameId,
    requireGameId = true,
    socket,
    requireSocket = true,
  } = options;

  if (requireTurn && !yourTurn) {
    return BATTLE_ACTION_ERROR.NOT_YOUR_TURN;
  }
  if (requireGameId && !gameId) {
    return BATTLE_ACTION_ERROR.MISSING_GAME_ID;
  }
  if (requireSocket && (!socket || socket.readyState !== 1)) {
    return BATTLE_ACTION_ERROR.CONNECTION_LOST;
  }
  return null;
}

export function isSessionAuthErrorMessage(message) {
  if (!message || typeof message !== 'string') {
    return false;
  }
  const lower = message.toLowerCase();
  return (
    lower.includes('jwt expired') ||
    lower.includes('tokenexpired') ||
    lower.includes('token expired') ||
    lower.includes('not_authenticated') ||
    lower.includes('not authenticated') ||
    lower.includes('authentication failed') ||
    lower.includes('auth failed')
  );
}
